namespace advisorop.components.common {

    class SelectCuInvestorServicerController {
        onInvestorSelected: any;
        selInvestor: domains.IInvestor;
        investor: domains.IInvestor;
        isInvestorFormVisible: boolean = false;
        label: string;
        advFirm: number;

        static $inject = ["advisorService", "servicerService"];
        constructor(public advisorService: services.AdvisorService,
            private servicerService: services.ServicerService) {
        }

        $onInit(): void {
            //this.noResults = true;
            this.isInvestorFormVisible = false;
        };

        $routerOnActivate(next, previous) {
        };

        search(searchTerm: string): ng.IPromise<{}> {
            // console.log(this.advFirm);
            return this.servicerService.searchInvestors(searchTerm, this.advFirm).then((response) => {
                    return response.data;
                });
        };

        onSelect(item, model, label, event): void {            
            var inv: domains.IInvestor = {};
            angular.copy(this.selInvestor, inv);
            this.resetSearch();
            this.onInvestorSelected({ investor: inv });    
        };
        
        resetSearch(): void {
            this.selInvestor = null;
            this.investor = null;
            this.isInvestorFormVisible = false;
            //this.noResults = true;
        };
        
        investorCreated(investor: domains.IInvestor): void {
            var inv: domains.IInvestor = {};
            angular.copy(investor, inv);
            this.resetSearch();
            this.onInvestorSelected({ investor: inv });                      
        };
    }



    class SelectCuInvestorServicer implements ng.IComponentOptions {

        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;

        constructor() {
            this.bindings = {
                onInvestorSelected: "&",
                label: "@",
                advFirm: '<'
            };
            this.controller = SelectCuInvestorServicerController;
            this.controllerAs = "vm";
            this.templateUrl = 'spa/servicer-module/components/select-cu-investor-servicer.html';
        }
    }
    angular.module(Constants.APP).component("selectCuInvestorServicer", new SelectCuInvestorServicer());


}